module.exports = __webpack_public_path__ + "img/5.acbbbf93.jpg";